export const HIGHLIGHT_LANGUAGES = [
   ['javascript', 'JavaScript'],
   ['css', 'CSS'],
   ['html', 'HTML'],
   ['php', 'PHP'],
   ['sql', 'SQL'],
   ['json', 'JSON'],
   ['python', 'Python'],
   ['java', 'Java'],
   ['csharp', 'C#'],
   ['c', 'C'],
   ['cpp', 'C++'],
   ['ruby', 'Ruby'],
   ['shell', 'Shell'],
   ['go', 'Go'],
   ['swift', 'Swift'],
   ['perl', 'Perl'],
   ['yaml', 'YAML'],
   ['markdown', 'Markdown'],
   ['plaintext', 'Plain Text'],
 ]

 export const HIGHLIGHT_FILETYPES = {
  javascript: 'js',
  css: 'css',
  html: 'html',
  php: 'php',
  sql: 'sql',
  json: 'json',
  python: 'py',
  java: 'java',
  csharp: 'cs',
  c: 'c',
  cpp: 'cpp',
  ruby: 'rb',
  shell: 'sh',
  go: 'go',
  swift: 'swift',
  perl: 'pl',
  yaml: 'yaml',
  markdown: 'md',
  plaintext: 'txt',
}